import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { poolsQueryKey, type PoolsQueryResponse } from "../pools-queries";
import { usePoolsAuthScope } from "./usePoolsAuthScope";
const fetchPools = async (signal?: AbortSignal): Promise<PoolsQueryResponse> => {
  const response = await fetch("/api/pools", {
    headers: {
      "Content-Type": "application/json"
    },
    signal
  });
  if (!response.ok) {
    throw new Error("Failed to fetch pools");
  }
  return response.json();
};
export const usePools = () => {
  const $ = _c(15);
  const {
    poolsFetchScope,
    poolsFetchPlanId,
    isPoolsFetchReady
  } = usePoolsAuthScope();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== poolsFetchScope) {
    t0 = poolsQueryKey(poolsFetchScope);
    $[0] = poolsFetchScope;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isPoolsFetchReady || $[3] !== t0) {
    t1 = {
      queryKey: t0,
      queryFn: _temp,
      enabled: isPoolsFetchReady,
      staleTime: 300000,
      gcTime: 1800000,
      refetchOnWindowFocus: false,
      refetchOnMount: false
    };
    $[2] = isPoolsFetchReady;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const query = useQuery(t1);
  let t2;
  let t3;
  if ($[5] !== isPoolsFetchReady || $[6] !== poolsFetchPlanId || $[7] !== poolsFetchScope || $[8] !== query.data || $[9] !== queryClient) {
    t2 = () => {
      if (!isPoolsFetchReady || !query.data) {
        return;
      }
      if (query.data.userPlan === poolsFetchPlanId) {
        return;
      }
      queryClient.invalidateQueries({
        queryKey: poolsQueryKey(poolsFetchScope)
      });
    };
    t3 = [isPoolsFetchReady, poolsFetchPlanId, poolsFetchScope, query.data, queryClient];
    $[5] = isPoolsFetchReady;
    $[6] = poolsFetchPlanId;
    $[7] = poolsFetchScope;
    $[8] = query.data;
    $[9] = queryClient;
    $[10] = t2;
    $[11] = t3;
  } else {
    t2 = $[10];
    t3 = $[11];
  }
  useEffect(t2, t3);
  const t4 = !isPoolsFetchReady || query.isLoading || query.isPending;
  let t5;
  if ($[12] !== query || $[13] !== t4) {
    t5 = {
      ...query,
      isLoading: t4
    };
    $[12] = query;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
function _temp(t0) {
  const {
    signal
  } = t0;
  return fetchPools(signal);
}